/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreditTrack } from '../../../../../hooks/useCreditTrack';
import { MonthlyExpenseStepProps } from '.';

export function useMonthlyExpense({ negativeDebts }: MonthlyExpenseStepProps) {
  const navigate = useNavigate();
  const { elementClickedEvent, elementViewedEvent, fieldInputtedEvent } = useCreditTrack();

  const hasNegativeDebts = Boolean(negativeDebts && negativeDebts.length > 0);

  const [showNegativeDebtsWarning, setShowNegativeDebtsWarning] = useState(hasNegativeDebts);

  const fieldValidators = {
    required: 'Por favor, insira um valor válido.',
    validate: {
      minValue: (value: string) => {
        const numericValue = parseFloat(
          value
            .replace(/R\$|\s/g, '')
            .replace(/\./g, '')
            .replace(/,/g, '.')
        );
        return numericValue >= 10 || 'O valor mínimo para continuar é R$ 10,00.';
      },
    },
  };

  useEffect(() => {
    if(showNegativeDebtsWarning) {
        elementViewedEvent({
        elementType: 'content',
        location: '/comparador',
        name: 'Dívida negativada encontrada',
        text: String(negativeDebts?.length),
      });
    }
  }, [showNegativeDebtsWarning, negativeDebts]);

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const fieldValue = e.target.value;

    if (!fieldValue) return;
    
    const payload = {
      formContext: {
        formBrand: 'mm-logged',
        formName: 'match-maker',
        formId: 'mm-logged',
        formType: 'default',
        formVersion: 'v2',
      },
      stepContext: {
        stepId: 'mm-logged-monthly-expense',
        stepName: 'Gasto mensal',
        stepNumber: 1,
      },
      userContext: {
        fieldId: 'monthly_expense',
        fieldLabel: 'Valor de gasto mensal',
        fieldName: 'monthly_expense',
        fieldType: 'text',
        fieldValue,
        autofilled: false,
      },
    };

    fieldInputtedEvent(payload);
  };

  const goToNegativeDebts = () => {
    elementClickedEvent({
      elementType: 'button/icon',
      name: 'Usuário negativado',
      location: '/comparador',
      text: 'Ir para débitos negativos',
    });

    navigate('/debitos-negativados');
  };

  const handleIgnoreNegativeDebts = () => {
    elementClickedEvent({
      elementType: 'button/icon',
      name: 'Usuário negativado',
      location: '/comparador',
      text: 'Continuar no comparador',
    });

    setShowNegativeDebtsWarning(false);
  };

  return {
    fieldValidators,
    showNegativeDebtsWarning,
    goToNegativeDebts,
    handleIgnoreNegativeDebts,
    handleOnBlur
  };
}
